import React, { useEffect, useState } from 'react'
import cx from 'classnames'
import jump from 'jump.js'
import vsbl from 'vsbl'

import { RenderModules } from 'src/utils/renderModules'

import { Header } from 'src/components/header'
import { ProductHero } from 'src/components/product/hero'
import { Image } from 'src/components/image'
import { PageLink } from 'src/components/link'
import { ProductCard } from 'src/components/product/card'
import { ProductSchema } from 'src/components/product/schema'

import { useSetPage } from 'src/context/siteContext'
import { SEO } from 'src/components/SEO'

export interface ProductProps {
  pageContext: {
    main: {
      modules: [],
      slug: {
        current: string
      },
      colorAssociation?: string
      title: string
    },
    meta: {}
    shopify: {}
  }
}
const handleJump = () => {
  const jumpy = document.querySelector('.js-inner')
  jump(jumpy, {
    offset: -76
  })
}

const Product = ({
  pageContext
}: ProductProps) => {
  const setPage = useSetPage()
  const [hidden, setHidden] = useState(false)
  const { main } = pageContext
  const {
    main: {
      modules,
      slug,
      colorAssociation
    },
    meta,
    shopify,
    products
  } = pageContext
  useEffect(() => {
    setPage(pageContext.main.slug.current)
  }, [0])

  useEffect(() => {
    const clear = document.querySelector('.js-product')
    const mainHeader = document.querySelectorAll('.js-header')[0]
    const vs = vsbl(clear, { threshold: 0})(() => {
      // nothing to see here
     }, () => {
       window.history.pushState({}, 'USBYUS', '/')
       mainHeader.classList.add('none')
       setHidden(true)
     })

     vs.update()
  })

  const url = `products/${slug.current}`
  return (
    <div className='ac'>
      <div dangerouslySetInnerHTML={{
          __html: `
            <script type="application/ld+json">
              ${JSON.stringify(ProductSchema(main, shopify))}
            </script>
          `
        }} />
      <SEO metaInfo={meta} pagePath={url} />
      <div className={cx('mxa x al site__main', pageContext.main.slug.current, colorAssociation)}>
        <div className={cx('js-product', {
          'none': hidden
        })}>
          <ProductHero main={pageContext.main} product={shopify} />
          <div className='container--xl px1 mxa outer f fw jcb ais'>
            {main.additionalImages && main.additionalImages.map((simage: any) => (
              <div className='x c50 py05' key={simage.asset._id}>
                <Image className='x' imageId={simage.asset._id} alt={main.title} />
              </div>
            ))}
          </div>
        </div>
        <div className='header__top rel header--blewp js-clear'>
          <div className='container--xl mxa px1 pt1 outer'>
            <div className='f x jcb aic'>
              <div>
                <PageLink to='/about' className=' s1 m0 p0 caps'>About</PageLink>
              </div>
              <div>
                <button onClick={() => handleJump()} className='m0 p0 s1 button h-underline caps'>Shop</button>
              </div>
            </div>
          </div>
          <div className='header__fine ac'>
            <span className='caps s1 '>Fine Art <span>for</span> Fine People</span>
          </div>
          <div className='x ac header__title'>
            <h1 className='display a-black'>US<span />BY<span />US</h1>
          </div>
        </div>
        <Header pathname='/' />
        <div className='js-inner'>
          <div className='container--xl outer  mxa'>
            <div className='f jcb fw ais'>
              {products.map(({ node }: {node: any}) => {
                if (node._rawContent.shopify.productId !== shopify.productId) {
                  return (
                    <ProductCard {...node._rawContent} key={node._rawContent.shopify.productId} />
                  )
                }
              })}
              <div className='c30 grid__product x' />
              <div className='c30 grid__product x' />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Product